import { publicInstance, setServiceUid } from './index';

export const fetchServiceInfo = async params => {
	try {
		return await publicInstance().get(`service/${params.serviceCode}`);
	} catch (error) {
		console.error(error);
	}
};

export const fetchTalk = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}/talk`, {
			params,
		});
	} catch (error) {
		console.error(error);
	}
};

export const fetchOptions = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}${params.path}`);
	} catch (error) {
		console.error(error);
	}
};

export const fetchFamilyRelations = async () => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}/code/PRC`);
	} catch (error) {
		console.error(error);
	}
};
